'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { DialogContent } from '../ui/dialog';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { SheetClose } from '../ui/sheet';

export function ProfileSuccessPasswordChangeDialog() {
  const { t } = useTranslations();

  return (
    <DialogContent
      overlayClassName="bg-black/30 backdrop-blur-none"
      hideClose={true}
      className={cn(
        'flex w-full max-w-[792px] flex-col items-center justify-center gap-6 rounded-[4px] border-none shadow-none sm:max-w-[792px]',
      )}
    >
      <div className="flex w-full flex-col items-center justify-center gap-3 sm:gap-4 lg:gap-6">
        <Image
          src={'/images/icons/green-check.svg'}
          alt="Check"
          width={56}
          height={56}
          className="object-contain"
        />
        <Heading
          title={t('text649')}
          tag="h4"
          className={{ container: 'items-center justify-center text-center', title: 'uppercase' }}
        />
        <Paragraph className="w-full max-w-[721px] text-center">{t('text3416')}</Paragraph>
        <SheetClose asChild>
          <Button asChild className="w-full sm:w-fit">
            <Link prefetch={false} href={ROUTES.PROFILE()}>
              {t('text1134')}
            </Link>
          </Button>
        </SheetClose>
      </div>
    </DialogContent>
  );
}

ProfileSuccessPasswordChangeDialog.id = 'PROFILE_SUCCESS_PASSWORD_CHANGE_DIALOG';
